// Static "About" content shown on the About page.
// Everything else (products, testimonials) previously lived in a mock data file
// and now comes from MongoDB via the products/comments APIs.

export const aboutContent = {
  mission:
    "At Infused by Daizy, we create magically charged ritual oils using traditional, old-world formulations. Each product is carefully crafted with sacred oils, anointed herbs, flowers, heartwoods, resins, and energy crystals.",
  story:
    "Every oil is hand-blended using all-natural premium absolutes and essential oils, then charged with intention during appropriate moon phases. We believe in the power of natural ingredients combined with spiritual energy to create transformative products for your magical practice.",
  values: [
    "100% Natural Ingredients",
    "Hand-blended with Intention",
    "Moon Phase Charged",
    "Ethically Sourced Crystals",
    "Traditional Formulations",
    "Sustainable Practices",
  ],
};
